angular.module('iqxCore').controller('CandidateShiftsCtrl', function ($scope, FormSvc, ApplicationSvc, ApiSvc, LanguageSvc, TerminologySvc) {
  $scope.loading = true
  $scope.showFilters = true
  $scope.terminology = {}
  $scope.theRecord = {}

  FormSvc.setOptions($scope, {
    fetchAPI: 'callresult/netcandidateshifts',
    fetchWithPersonID: true,
    multiRow: true,
    autoEdit: true,
    doNotPreventNav: true,
    dateFields: ['ShiftDate'],
    timeFields: ['TimeFrom', 'TimeTo']
  })

  $scope.classes = { label: 'col-sm-6', data: 'col-sm-6' }

  $scope.shifts = []
  var defaultSettings = {
    pPersonID: ApplicationSvc.currentUser.personID, // Required
    pDateFrom: new Date(), // If empty defaults to today
    pDateTo: '', // If empty defaults to 7 days after pDateFrom
    pExplicitlyAvailableOnly: false, // Otherwise returns all for which not unavailable. Default false.
    pPreviouslyWorkedOnly: 'N', // 'C' for previously worked in same company, 'V' for same vacancy. Default 'N' for neither.
    pPersonRequirementsSatisfied: false, // Person requirements in IQX. Always obeyed if individual's requirements are set to mandatory in IQX. Default false.
    pVacancyRequirementsSatisfied: true, // Vacancy requirements in IQX. Default true.
    pExactGradeOnly: false, // Otherwise returns shifts with required grade <= to candidate's grade. Default false.
    pIpoint: false // Use the specially optimised custom algorithm (This must be explicitly configured in the database or you will get an error). Default false.
  }
  $scope.theRecord = angular.copy(defaultSettings)

  $scope.update = $scope.fetchShifts

  $scope.getRegistration = function () {
    // removed netCandidateRegDetails because we already call it in initSession.svc.js. It was already available and didn't break when I took it out.

    TerminologySvc.getTerminology([
      // Fetch the terminology for the ones we're interested in.
      'candShifts_shifts',
      'candShifts_filters',
      'candShifts_fetch',
      'candShifts_startOn',
      'candShifts_explicitlyAvailable',
      'candShifts_dateStart',
      'candShifts_from',
      'candShifts_to',
      'candShifts_position',
      'candShifts_location',
      'candShifts_apply',
      'candShifts_applied',
      'candShifts_shortlist',
      'candShifts_shortlisted',
      'candShifts_noJobs'
    ])
      .then(function (value) {
        $scope.terminology = value // Set terminology to the value returned by the promise

        $scope.setEditing(true)
        $scope.theRecord.pExplicitlyAvailableOnly = ApplicationSvc.params.behaviour.CSSEXPLICITLYAVAILABLEONLY
        $scope.theRecord.pPreviouslyWorkedOnly = ApplicationSvc.params.behaviour.CSSPREVIOUSLYWORKEDONLY
        $scope.theRecord.pPersonRequirementsSatisfied = ApplicationSvc.params.behaviour.CSSPERSONREQUIREMENTSSATISFIED
        $scope.theRecord.pVacancyRequirementsSatisfied = ApplicationSvc.params.behaviour.CSSVACANCYREQUIREMENTSSATISFIE
        $scope.theRecord.pExactGradeOnly = ApplicationSvc.params.behaviour.CSSEXACTGRADEONLY
        $scope.theRecord.pIpoint = ApplicationSvc.params.behaviour.pIpoint

        $scope.loading = false
      })
      .catch(function (error) {
        console.error(error)
      })
  }

  $scope.fetchShifts = function () {
    // The PopulateCandidateShifts service populates the IQXNetCandidateShifts table with shifts matching candidate's skills and availability based on criteria in $scope.theRecord
    $scope
      .exec('service/PopulateCandidateShifts', $scope.theRecord)
      .then(function () {
        return $scope.fetch()
      })
      .then(function () {
        $scope.showFilters = false
      })
  }

  $scope.bookShift = function (shift) {
    $scope
      .exec('call/NetPreValidateCandidateShiftBooking', { pPersonID: ApplicationSvc.currentUser.personID, pTempShiftPlanID: shift.TempShiftPlanID, pVacancyID: shift.VacancyID })
      .then(function (res) {
        return $scope.exec('call/NetCandidateShiftBook', { pPersonID: ApplicationSvc.currentUser.personID, pTempShiftPlanID: shift.TempShiftPlanID })
      })
      .then(function () {
        shift.bookStatus = LanguageSvc.lang.candidate.shifts.bookedStatus.you
      })
      .catch(function (err) {
        if (err && err.iqxError) {
          switch (err.iqxError.errorNumber) {
            case '130':
              shift.bookStatus = LanguageSvc.lang.candidate.shifts.bookedStatus.notAvailable
              break
            case '131':
              shift.bookStatus = LanguageSvc.lang.candidate.shifts.bookedStatus.someoneElse
              break
            case '102':
              break
            default:
              shift.bookStatus = err.iqxError.text
          }
        }
      })
  }

  $scope.getRegistration()
})
